import '@take-2/fd-modules/theater/details/desktop.app';
